// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';

// utilities
import { map, forEach } from 'lodash';
import cx from 'classnames';
import CloseX from '../../../../common/svgs/CloseX';

function GenericCard(props) {
  const {
    title,
    subtitle,
    color,
    content,
    unpin
  } = props;

  let contentRows = [];
  let currentRow = [];
  forEach(content, (section, index) => {
    currentRow.push(section);
    if (index % 2 == 1 || index == content.length - 1) {
      if (currentRow.length)
        contentRows.push(currentRow);
      currentRow = [];
    }
  });

  return (
    <div
        data-id={`Card for ${title}`}
        className={cx('generic-card')}>
      <div className='status-container'>
        <div className='status-circle' data-id='Status Icon'

          style={{backgroundColor: color, borderColor: color, color: color}}></div>
      </div>
      <div className='generic-card-info' >
        <div className='card-info-primary'>
          <div className='card-title' data-id='Title'>
            {title}
          </div>
          <div className='card-subtitle' data-id='Subtitle'>
            {subtitle}
          </div>
        </div>

        <div className='grid'>
          {map(contentRows, (row) =>
            <div className='row'>
              {map(row, (section) =>
                <div className='col'>{section}</div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className='card-close'
        data-id='close-icon'
        onClick={unpin}
      >
        <CloseX />
      </div>
    </div>
  );
}

GenericCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  color: PropTypes.string,
  content: PropTypes.object,
  unpin: PropTypes.func
};


export default GenericCard;



// WEBPACK FOOTER //
// ./shared/react/admin/CorkBoard/GenericCard/index.js